import { render, staticRenderFns } from "./NutrientContentDialog.vue?vue&type=template&id=30108538&scoped=true"
import script from "./NutrientContentDialog.vue?vue&type=script&lang=js"
export * from "./NutrientContentDialog.vue?vue&type=script&lang=js"
import style0 from "./NutrientContentDialog.vue?vue&type=style&index=0&id=30108538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30108538",
  null
  
)

export default component.exports